export const changeLimitDropDownData = "changeLimitDropDownData";
export const addNewReward = "addNewReward";
export const setRewardIndex = "setRewardIndex";
export const setFormVisibility = "setFormVisibility";
export const setRewardFormData = "setRewardFormData";
export const deleteRewardLimitByIndex = "deleteRewardLimitByIndex";
export const resetLimit = "resetLimit";
export const saveCompleteReward = "saveCompleteReward";
  